import { useAuth0 } from '@auth0/auth0-react';
import axios, { AxiosInstance } from 'axios';
import { useEffect, useRef, useState } from 'react';

import { USER_AGENT, VITE_URL_SERVICE } from '@/utils/envs';

import useExampleRequest, { ExampleRequest } from './rest/useExampleRequest';
import useIzziRequest, { IzziRequest } from './rest/useIzziRequest';

export interface HttpProviderContext {
  http: AxiosInstance;
  httpNoAuth: AxiosInstance;
  httpIsReady: boolean;
  examples: ExampleRequest;
  izzi: IzziRequest;
}

export function useHttpProvider(): HttpProviderContext {
  const { getAccessTokenSilently } = useAuth0();
  const httpInstance = useRef<AxiosInstance>(axios.create({}));
  const httpNoAuthInstance = useRef<AxiosInstance>(axios.create({}));
  const [httpIsReady, setHttpIsReady] = useState(false);

  const examples = useExampleRequest(httpInstance);
  const izzi = useIzziRequest(httpInstance);

  useEffect(() => {
    const instance = axios.create({
      baseURL: VITE_URL_SERVICE,
      headers: {
        'User-Agent': USER_AGENT,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    const noAuthInstance = axios.create({
      baseURL: VITE_URL_SERVICE,
      headers: {
        'User-Agent': USER_AGENT,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    instance.interceptors.request.use(async (config) => {
      try {
        const token = await getAccessTokenSilently({});
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        } else {
          console.warn('Token no encontrado.');
        }
      } catch (error) {
        console.error('Error al obtener el token de acceso:', error);
      }
      return config;
    });

    httpInstance.current = instance;
    httpNoAuthInstance.current = noAuthInstance;
    setHttpIsReady(true);
  }, [getAccessTokenSilently]);

  return {
    http: httpInstance.current,
    httpNoAuth: httpNoAuthInstance.current,
    httpIsReady,
    examples,
    izzi,
  };
}
